<template>
  <div class="n-detail-panel n-card p-4">
    <slot />
  </div>
</template>

<script setup></script>

<script>
export default {
  name: 'NDetailPanel',
};
</script>

<style lang="less">
.n-detail-panel {
  &-label {
    margin-right: 10px;
    @apply tracking-tight text-stone-800 font-medium;

    &::after {
      content: ':';
    }
  }

  &-content {
    @apply tracking-tight font-light opacity-90;
  }

  &-id {
    @apply text-lg;
    color: var(--ant-primary-color) !important;

    .n-detail-panel-label {
      color: var(--ant-primary-color) !important;
      @apply decoration-solid font-normal;
    }
  }
}
</style>
